module.exports = __webpack_public_path__ + "static/media/icon-barcode.cfe9be77.svg";